import { render, staticRenderFns } from "./NewChatHistoryDetail.vue?vue&type=template&id=4a6c9aaa"
import script from "./NewChatHistoryDetail.vue?vue&type=script&lang=js"
export * from "./NewChatHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports